export default {
  MOVE_SELECTION_TO_SECTION: 'moveSelectionToSection',
  SHARE_SELECTION: 'shareSelection',
  DELETE_SELECTION: 'deleteSelection'
};
